<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Nomination - {{this.subTitle}}</h2>
			</b-col>
			<b-col lg="6">
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
								<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="edittarget">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteTargets" >Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>
		<div>
			<b-row v-if="loadingData">
					<b-col cols="12" sm="12" md="12" lg="12">
						<p class="text-center">
							<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
						</p>
					</b-col>
				</b-row>
				<b-card v-else>
					<b-col md="8">
						<b-form-group :label-cols="4" horizontal label="Id" label-for="id" >
								<b-form-input class="plaintext-input" plaintext id="id" v-model="model.id" type="text"></b-form-input>
						</b-form-group>
						<b-form-group v-show="view" :label-cols="4" horizontal label="Energy Company" label-for="target0">
							<b-form-input v-show="!edit" class="plaintext-input" plaintext id="target0" v-model="model.energy_company_name" type="text"></b-form-input>
							<b-form-select v-show="edit" id="target0" v-model="model.energy_company_id" :options="energycompanies" @input="select_energy_companies"/>
						</b-form-group>
					<!--	<b-form-group :label-cols="4" horizontal label="Fluid Type" label-for="Grouptarget2">
							<b-form-input v-show="!edit" class="plaintext-input" plaintext id="Grouptarget2" v-model="model.fluid_type_name" type="text"></b-form-input>
							<b-form-select v-show="edit" :disabled="fluids.length == 0" id="Grouptarget2" v-model="model.fluid_type_id" :options="fluids"/>@input="FTChange"
						</b-form-group> -->
						<b-form-group v-if="model.fluid_types.length > 0 && !edit" :label-cols="4" id="L5" label="Fluid Types" label-for="loadLocationsID" horizontal>
									<b-form-checkbox-group text-field="name" class="custom-checkboxes" :options="model.fluid_types" name="Checkboxes22" :checked="true" plain disabled></b-form-checkbox-group>
						</b-form-group>
						<b-form-group v-if="fluids.length > 0 && edit" :label-cols="4" id="L2" label="Fluid Types" label-for="Grouptarget2" horizontal>
              <b-form-checkbox-group class="custom-checkboxes" :options="fluids" name="Checkboxes2" plain v-model="model.fluid_type_ids" @input="FTChange"></b-form-checkbox-group>
              <b-form-checkbox style="margin-top: 15px;" v-model="ftAllSelected" :indeterminate="indeterminateFT" aria-describedby="" aria-controls="" plain @change="FTToggleAll">
                {{ ftAllSelected ? 'Un-select All' : 'Select All' }}
              </b-form-checkbox>
            </b-form-group>
						<b-form-group :label-cols="4" horizontal label="Unload Location" label-for="Grouptarget1">
							<b-form-input v-show="!edit" class="plaintext-input" plaintext id="Grouptarget1" v-model="model.location_name" type="text"></b-form-input>
							<b-form-select v-show="edit" :disabled="locations.length == 0"  id="Grouptarget1" v-model="model.location_id" :options="locations"/>
						</b-form-group>
						<b-form-group :label-cols="4" horizontal label="Initial Date" label-for="initial_date">
							<b-form-input v-show="!edit" class="plaintext-input" plaintext id="initial_date" v-model="initial_date" type="text"></b-form-input>
							<b-form-input v-show="edit" id="initial_date" v-model="model.initial_date" type="date"></b-form-input>
						</b-form-group>
						<b-form-group :label-cols="4" horizontal label="End Date" label-for="end_date">
							<b-form-input v-show="!edit" class="plaintext-input" plaintext id="end_date" v-model="end_date" type="text"></b-form-input>
							<b-form-input v-show="edit" id="end_date" v-model="model.end_date" type="date"></b-form-input>
						</b-form-group>
						<b-form-group :label-cols="4" horizontal label="Volume" label-for="target5">
							<b-form-input v-show="!edit" class="plaintext-input" plaintext id="target5" v-model="model.formatVolume" type="text"></b-form-input>
							<b-form-input v-show="edit" placeholder="0.00" id="target5" v-model="model.volume" @keydown.native="myOnlyNumber($event, 'volume')" @blur.native="inputBlur('volume')" ></b-form-input>
						</b-form-group>

						<div v-if="edit" slot="footer">
							<b-button @click="updateTarget" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
						<b-button  @click="edittarget" size="sm" ><i class="fa fa-ban"></i> Cancel</b-button>
					</div>
				</b-col>
			</b-card>
		</div>
	</div>
</template>

<script>
	// ********** imports ************ //
	import Vue from 'vue'
	import targets from './targets'
	import axios from 'axios'
	import {
		apiDomain
	} from '../../config'
	import fluidtypes from '../m_fluid_types/fluidtypes'
	import moment from 'moment';

	export default {
		name: 'target',
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		created: function() {
			this.getTargetData()
		},
		data() {
			return {
				fluids					: [],
				locations				: [],
				energycompanies	: [],
				subTitle				: '',

				model						: {
					id								: null,
					energy_company_id	: '',
					location_id				: '',
					//fluid_type_id			: '',
					fluid_type_ids 		: [],
					fluid_types				: [],
					initial_date			: '',
					end_date					: '',
					volume						: '',
					formatVolume			: '',
					initial_date_date	: '',
					end_date_date			: '',
					hauls							: [],
				},

				loadingData			: true,
				tabIndex				: 0,
				found						: false,
				notFoundMessage	: 'Not found',
				item						: [],

				edit						: false,
				originalData		: null,
				dataUpdate			: null,
				role						:'',
				view						:true,
				energy_company_id :null,
				initial_date 		:'',
				end_date 				:'',
				indeterminateFT	: false,
				ftAllSelected		: false,
			}
		},
		methods: {
			FTChange() {
				let  fluid_type_ids  = this.model.fluid_type_ids
					if (fluid_type_ids === true) {
						return
					}
				if (fluid_type_ids.length === 0) {
					this.indeterminateFT = false
					this.ftAllSelected = false
				} else if (fluid_type_ids.length === this.fluids.length) {
					this.indeterminateFT = false
					this.ftAllSelected = true
				} else {
					this.indeterminateFT = true
					this.ftAllSelected = false
				}
			},
			FTToggleAll(checked) {
				this.model.fluid_type_ids = checked ? this.fluids.map(item => {
					return item.value
				}) : []
      },
			inputBlur(variableName) {
        let variableValue = this.model[variableName]
        if (variableValue.length == 0) {
          this.model[variableName] = "0.00"
        } else {
          let tempValue = variableValue.split(".")
          if (tempValue.length == 1) {
            this.model[variableName] = String(variableValue) + ".00"
          } else if (tempValue.length == 2) {
            this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2)
          }
        }
      },
      myOnlyNumber(evt, variableName) {
        let dotPosition = this.model[variableName].indexOf(".")
        let hasDot = dotPosition > -1
        let length = this.model[variableName].length
        this.isNumber(evt, hasDot, dotPosition, length)
      },
      isNumber: function(evt, hasDot, dotPosition, length) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        // if (charCode <= 31 || charCode == 37 || charCode == 39 || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190))) {
				if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
          let selectionStart = evt.target.selectionStart;
          let selectionEnd = evt.target.selectionEnd;
          if ((hasDot && (selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart) && length - 2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
            evt.preventDefault();
          } else {
            return true
          }
        } else {
          evt.preventDefault();
        }
      },
			select_energy_companies() {
        this.fluids = []		
        let energycompanies = this.dataUpdate.energy_companies
        let energy_company_index = energycompanies.map(o => o.id).indexOf(this.model.energy_company_id)
        if (energy_company_index > -1) {
          let fluid_types = energycompanies[energy_company_index].fluid_types
          this.fluids = fluid_types.map(item => {
											return { 'value': item.id, 'text': item.name }
					})
        }
      },
			edittarget() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					if (this.role =='super_admin') {
						let energycompanies = this.dataUpdate.energy_companies
						this.model.energy_company_id = this.originalData.energy_company_id
						let energy_company_index = energycompanies.map(o => o.id).indexOf(this.model.energy_company_id)
						if(energy_company_index > -1) {
							let fluid_types = energycompanies[energy_company_index].fluid_types
							this.fluids = fluid_types.map(item => {
									return { 'value': item.id, 'text': item.name }
							})
							
						}
					}	  
					this.model.fluid_type_ids  = this.model.fluid_types.map(item => item.id )
					this.model.volume = this.replaceAll(this.model.volume,',','')
					this.edit = true
				}
			},
			restoreOriginalData() {
				let model = {
					...this.originalData,
				}
				this.model 				= JSON.parse(JSON.stringify(model))
				this.model.fluid_type_ids  = this.model.fluid_types.map(item => item.id )
				this.initial_date = moment(this.model.initial_date).format('MMM DD, YYYY')
				this.end_date 		= moment(this.model.end_date).format('MMM DD, YYYY')
			},
			getTargetData() {
				this.loadingData = true
				targets.getBy(this.id)
					.then(data => {
						if (data[0] === 'success') {
							this.originalData = data[1]
							this.dataUpdate 	= data[2]

							this.loadingData = false
							this.subTitle = this.originalData.energy_company_name
							this.found = true
							this.edit = false

							this.locations = this.dataUpdate.unloads_locations.map(item => {
                      return { 'value': item.id, 'text': item.name }
              })
              if (this.locations.length == 1) {
                this.model.location_id = this.locations[0].value
              } else {
                this.model.location_id = ''
							}
							
							this.role = data[3]
              if (this.role =='super_admin') {
                  this.view=true
									this.energycompanies = this.dataUpdate.energy_companies.map(item => {
                      return { 'value': item.id, 'text': item.company_name }
											//return { text: item.name, value: item.id }
									})
              } else if (this.role =='super_analyst' || this.role =='analyst'|| this.role =='marketing_accountant') {
									this.view=false
									this.energy_company_id = data[4]
									let fluid_types = this.dataUpdate.energy_companies[0].fluid_types
                  this.fluids = fluid_types.map(item => {
											return { 'value': item.id, 'text': item.name }
									})
							}
							this.restoreOriginalData()

						} else {
							  Vue.swal(data[0], data[1], data[0])
							this.loadingData = false
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
				if (this.role =='super_admin') {
						if(this.model.energy_company_id === undefined || this.model.energy_company_id.length == 0 ) {
							this.$swal('Alert!', 'Energy Company not selected', 'warning')
							return false
						}
				}
				if (this.model.fluid_type_ids === undefined || this.model.fluid_type_ids.length == 0) {
					this.$swal('Alert!', 'Fluid Type not selected', 'warning')
          return false
				} else if (this.model.location_id === undefined || this.model.location_id.length == 0) {
					this.$swal('Alert!', 'Unload Location not selected', 'warning')
					return false
        } else if (this.model.volume === undefined || this.model.volume.length == 0) {
          this.$swal('Alert!', 'Water Actual can not be empty', 'warning')
          return false
        }

        try {
          let startDateValidation = (new Date(this.model.initial_date)).getFullYear()
          if(startDateValidation <= 2000 || startDateValidation >= 2100 || isNaN(startDateValidation)) {
            throw ''
          }
        } catch (error) {
          this.$swal('Alert!', 'Initial Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning')
          return false
        }

        try {
          let endDateValidation = (new Date(this.model.end_date)).getFullYear()
          if(endDateValidation <= 2000 || endDateValidation >= 2100 || isNaN(endDateValidation)) {
            throw ''
          }
        } catch (error) {
          this.$swal('Alert!', 'End Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning')
          return false
        }

        return true
      },
			updateTarget() {
				this.inputBlur('volume')
				if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
							this.model.energy_company_id=this.energy_company_id
				}
        if (!this.okToUpdate()) {
          return
				}
        let model = {
          location_id 		: this.model.location_id,
          fluid_type_id 	:	this.model.fluid_type_ids,
          energy_company_id : this.model.energy_company_id,
          initial_date 			: this.model.initial_date,
          end_date 					: this.model.end_date,
					volume						: parseFloat(parseFloat(this.model.volume.replace(',', '')).toFixed(2)),
					hauls							: this.model.hauls,
				}
				targets.update(this.id, model)
					.then((data) => {
						this.$swal(data[0], data[1], data[0])
						if (data[0] == 'success') {
							this.getTargetData()
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.edit=false
			},
			deleteTargets() {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Target?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						targets.delete(this.id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.filter = ''
									this.$router.push('/targets')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			replaceAll( text, busca, reemplaza ){
  			while (text.toString().indexOf(busca) != -1)
      		text = text.toString().replace(busca,reemplaza);
  			return text;
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/m_targets/m_target.vue